import { useCallback } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { ROUTE_KEYS } from '@/navigation/constants';

export interface UseNjInheritanceTaxAnnouncementProps {
  onClose: () => void;
  householdId: string;
}

export function useNjInheritanceTaxAnnouncement({
  onClose,
  householdId,
}: UseNjInheritanceTaxAnnouncementProps) {
  const { navigate } = useNavigateToRoute();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleLearnMore = useCallback(() => {
    window.open(
      'https://academy.withluminary.com/articles/1832714831-inheritance-tax',
      '_blank'
    );
  }, []);

  const handleTryItOut = useCallback(() => {
    navigate(ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB, {
      householdId,
    });
    handleClose();
  }, [handleClose, householdId, navigate]);

  return {
    heading: 'New Jersey inheritance tax',
    imageUrl: 'nj-inheritance-tax-announcement.png',
    imageAlt: 'New Jersey inheritance tax',
    bodyText:
      'Automatically calculate New Jersey inheritance tax on direct transfers to non-exempt beneficiaries — factored directly into your estate waterfall.',
    actionButtons: (
      <>
        <Button variant="secondary" size="sm" onClick={handleLearnMore}>
          Learn more
        </Button>
        <Button variant="primary" size="sm" onClick={handleTryItOut}>
          Try it out
        </Button>
      </>
    ),
  };
}
